var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between card"},[_c('h4',{staticClass:"mb-3 mt-2 text-sm bold"},[_vm._v(" Please choose a tab on the left. If you feel that a tab is missing here, please speak with your Hera Administrator. ")])])
}]

export { render, staticRenderFns }